var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:{
    'ui-btn': !_vm.lg && !_vm.xl,
    'ui-btn-lg': _vm.lg,
    'ui-btn-xl': _vm.xl,
    'btn-off': _vm.off,
    'btn-solid': !_vm.outlined,
    'btn-outlined': _vm.outlined,
  }},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }